import { z } from "zod";

export type SapErrorResponse = z.infer<typeof SapErrorSchema>;

const ParameterSchema = z.object({
  Group: z.string().optional().nullable(),
  Name: z.string().or(z.number()).optional().nullable(),
  Value: z.string().optional().nullable(),
});

const ErrorDetailSchema = z.object({
  Type: z.string().optional().nullable(),
  Code: z.string().optional().nullable(),
  Text: z.string().optional().nullable(),
  Parameter: ParameterSchema.or(z.array(ParameterSchema)).nullable().optional(),
});

export const SapErrorSchema = z
  .object({
    errors: ErrorDetailSchema.or(z.array(ErrorDetailSchema)),
  })
  .transform(data => {
    if (Array.isArray(data.errors)) {
      return { errors: data.errors };
    }

    return { errors: [data.errors] };
  });
